import { MainContent } from "shared/styles";
import { CreateBandInvitationForm } from "Bands/containers";
import { Card } from "shared/components";
import { copy } from "shared/assets";
import { User } from "shared/assets/icons";

export const CreateInvitationPage = () => {
  return (
    <MainContent>
      <Card title={copy.members.createMember.title} icon={User}>
        <CreateBandInvitationForm />
      </Card>
    </MainContent>
  );
};
